import {
	AppPage,
	MimaFilter,
	MimaText,
	MimaDateFilter,
	QuickLinksComponent as QLC,
	BusinessInsightComponent as BIC,
	Searchbar,
	MimaButton,
	PageLoader,
} from '../../components';
import {
	CreateDeductionContainer,
	SaleSheetUploadContainer,
} from '../../containers';
import styles from '../../assets/styles/Commission/Commission.module.scss';
import { downloadFormatDate, downloadXlsx2 } from '../../utils/download';
import { amountFormatter } from '../../utils/utils';
import { AnimatePresence } from 'framer-motion';
import React, { useState } from 'react';
import { Formik } from 'formik';

const Commission = ({
	filterPeriod,
	validationSchema,
	onSubmit,
	loading,
	resetFilter,
	refresh,
	salesList,
	comTypeModal,
	saleSheetModal,
	showComTypeModal,
	showSaleSheetModal,
	closeModal,
}) => {
	const [onReset, setOnReset] = useState(false);
	const [filteredSales, setFilteredSales] = useState([]);
	const printData = filteredSales.map(sale => ({
		'Employee Name': `${sale.employee?.user.firstname} ${
			sale.employee?.user?.middlename || ''
		} ${sale.employee?.user?.lastname}`,
		Username: sale?.username,
		Product: sale?.productSaleConfig?.name,
		'Product Identifier': sale?.productSaleConfig?.identifier,
		'Sale ID': sale.salesId,
		Quantity: sale.quantity,
		Point: sale.point,
		'Sales Date': sale.salesDate,
	}));
	return (
		<AppPage pageTitle="Sales Agent Report">
			<MimaText variant="subtitle" mb={2} align="center">
				You are viewing Sales Agents information for {filterPeriod}
			</MimaText>
			<Formik
				initialValues={{
					startDate: '',
					endDate: '',
				}}
				validationSchema={validationSchema}
				onSubmit={onSubmit}>
				{({
					handleChange,
					handleBlur,
					handleSubmit,
					setFieldValue,
					values,
					errors,
					touched,
				}) => (
					<MimaFilter
						filterClick={() => {
							setOnReset(false);
							handleSubmit();
						}}
						loading={loading}
						resetClick={() => {
							setOnReset(true);
							resetFilter();
						}}>
						<MimaDateFilter
							labelTitle="start date"
							name="startDate"
							value={!onReset ? values.startDate : ''}
							onChange={text => {
								setOnReset(false);
								setFieldValue('startDate', text);
							}}
							onBlur={handleBlur}
							width={18}
							touched={touched.startDate}
							error={errors.startDate}
						/>
						<MimaDateFilter
							labelTitle="End date"
							name="endDate"
							value={!onReset ? values.endDate : ''}
							onChange={text => {
								setOnReset(false);
								setFieldValue('endDate', text);
							}}
							onBlur={handleBlur}
							width={18}
							touched={touched.endDate}
							error={errors.endDate}
						/>
					</MimaFilter>
				)}
			</Formik>
			<div className="searchInMiddle">
				<Searchbar
					placeholder="Search Sales"
					variant="wide"
					input={salesList}
					loading={false}
					output={setFilteredSales}
					handleFilter={(item, searchQuery) => {
						return (
							item?.productSaleConfig.name
								?.toLowerCase()
								?.includes(searchQuery) ||
							`${item?.employee?.user?.firstname?.toLowerCase()} ${item?.user?.lastname?.toLowerCase()}`?.includes(
								searchQuery
							) ||
							item.username?.toLowerCase()?.includes(searchQuery) ||
							item?.productSaleConfig.identifier
								?.toLowerCase()
								?.includes(searchQuery) ||
							item?.salesId?.toLowerCase()?.includes(searchQuery)
						);
					}}
				/>
			</div>
			<MimaText mt={4} variant="bodyBold" align="center">
				You are viewing Sales Table{' '}
			</MimaText>
			<div className={styles.main_nav}>
				<div onClick={showSaleSheetModal} className={styles.main_nav_item}>
					Upload Sales Sheet
				</div>
				<div onClick={showComTypeModal} className={styles.main_nav_item}>
					 Deductions
				</div>
				<div
					className={styles.main_nav_item}
					onClick={() => {
						downloadXlsx2(
							printData,
							`sales-report-${downloadFormatDate(new Date())}`
						);
					}}>
					Download Report
				</div>
			</div>
			<div className="whiteTable">
				<MimaButton
					title="Refresh"
					variant="filter"
					onClick={() => refresh()}
					width={10}
				/>

				<>
					{loading ? (
						<PageLoader
							title="While we fetch your employee Details"
							loading={loading}
						/>
					) : (
						<table>
							<thead>
								<tr>
									<th> Employee </th>
									<th> Username </th>
									<th> Product </th>
									<th> Product Identifier</th>
									<th> Sales Id </th>
									<th> quantity </th>
									<th> Points</th>
									<th> Sales Date </th>
								</tr>
							</thead>
							<tbody>
								{filteredSales.map((sale, key) => (
									<tr key={key}>
										<td>
											{`${sale?.employee?.user.firstname} ${sale?.employee?.user.lastname}`}
										</td>
										<td>{sale.username}</td>
										<td>{sale.productSaleConfig?.name}</td>
										<td>{sale.productSaleConfig?.identifier}</td>
										<td>{sale.salesId}</td>
										<td>{sale.quantity}</td>
										<td>{sale.point}</td>
										<td>{sale.salesDate}</td>
									</tr>
								))}
							</tbody>
						</table>
					)}
				</>
			</div>

			{(comTypeModal || saleSheetModal) && (
				<div className="modal">
					<AnimatePresence>
						{comTypeModal && (
							<CreateDeductionContainer closeModal={closeModal} />
						)}
						{saleSheetModal && (
							<SaleSheetUploadContainer closeModal={closeModal} />
						)}
					</AnimatePresence>
				</div>
			)}
		</AppPage>
	);
};

export default Commission;
